export function adjustSliderBreakpoints() {
    const isBrowserSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isBrowserSafari ? document.documentElement.clientWidth - window.innerWidth : 0;
}
//# sourceMappingURL=adjustsSliderBreakpoints.js.map
